import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication,EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { fetchConfig } from './config/configService';
import { AppConfigProvider } from './config/AppConfigContext';
import { LogLevel } from "@azure/msal-browser";


let msalInstance=null;
(async function initApp() {
    try {
        const config = await fetchConfig();
        
        const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
        const rootElement = document.getElementById('root');
        const root = createRoot(rootElement);
        const msalConfig = {
        auth: {
            //clientId: process.env.REACT_APP_CLIENT_ID,
            //authority: process.env.REACT_APP_AUTHORITY,
            //knownAuthorities: knownAuthorities,
            //redirectUri: process.env.REACT_APP_REDIRECT_URI,
            clientId: config.clientId,
                authority: config.authority,
                    knownAuthorities: config.knownAuthorities,
                        redirectUri: config.redirectUri,
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                }
            }
        },
        tokenRequest: {
            //scopes: [process.env.REACT_APP_SCOPE],
            scopes: [config.apiScopes],
        },
        loginRequest: {
            scopes: [config.apiScopes],
        }
    };

    msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getActiveAccount());
}

        msalInstance.addEventCallback(event => {
            if (event.eventType === EventType.LOGIN_START) {
                msalInstance.setActiveAccount(event.payload.account);
            }
            if (event.eventType === EventType.LOGIN_SUCCESS) {
                msalInstance.setActiveAccount(event.payload.account);
            }
            if (event.eventType === EventType.LOGIN_FAILURE) {
                if (event.error) {
                    console.log(event.error);
                }
            }
        });
            root.render(
                <BrowserRouter basename={baseUrl}>
                    <MsalProvider instance={msalInstance}>
                        <AppConfigProvider config={config}>
                            <App />
                        </AppConfigProvider>
                    </MsalProvider>
                </BrowserRouter>);
            // If you want your app to work offline and load faster, you can change
            // unregister() to register() below. Note this comes with some pitfalls.
            // Learn more about service workers: https://cra.link/PWA
            serviceWorkerRegistration.unregister();

            // If you want to start measuring performance in your app, pass a function
            // to log results (for example: reportWebVitals(console.log))
            // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
            reportWebVitals();
        }
        catch (err) {

        }
})();

//export const login = async () => {
//    try {
//        const config = await fetchConfig();
//        const loginRequest = {
//            scopes: [config.apiScopes]
//        };

//        const loginResponse = await msalInstance.loginRedirect(loginRequest);
//        console.log(loginResponse);
//        return loginResponse.account;
//    } catch (error) {
//        console.error('Error logging in:', error);
//        throw error;
//    }
//};
export function loginRequest(config) {
    return {
        scopes: [config.apiScopes],
    }
};

export const GetAccessToken = async (scopes) => {
    await msalInstance.initialize();
    try {
        //const accessTokenRequest = {
        //    scopes
        //};
        const tokenResponse = await msalInstance.acquireTokenSilent(scopes);
        console.log(tokenResponse);
        return tokenResponse.accessToken;
    }
    catch (error) {
        console.error("getting error", error);
        throw error;
    }

};


